import FeatureCarousel from "@/components/landing/FeatureCarousel";
import { motion } from "motion/react";
import feature1Bg from "@/assets/landing/card_1.svg";
import feature2Bg from "@/assets/landing/cardbg2.png"
import feature3Bg from "@/assets/landing/card_3.svg";
import feature4Bg from "@/assets/landing/card_4.svg";
import iconCard1 from "@/assets/landing/icon_card1.svg";
import iconCard2 from "@/assets/landing/icon_card2.svg";
import iconCard3 from "@/assets/landing/icon_card3.svg";
import iconCard4 from "@/assets/landing/icon_card4.svg";

export default function WhyAirtalentMakesADifference() {
  return (
    <section className="bg-white w-full min-h-[600px] relative overflow-hidden">
      {/* Full-width diagonal banner */}
      <motion.div
        className="flex justify-center items-center my-6 min-[375px]:my-8 min-[425px]:my-10 sm:my-12 lg:my-16 xl:my-34 relative h-[100px] min-[375px]:h-[120px] min-[425px]:h-[140px] sm:h-[140px] lg:h-[220px] xl:h-[240px] w-full"
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
      >
        <div
          className="w-[150vw] h-[60px] min-[375px]:h-[80px] min-[425px]:h-[100px] sm:h-[100px] lg:h-[170px] xl:h-[230px] bg-[#ff7a00] flex items-center justify-center z-10 absolute"
          style={{
            transform: "rotate(-6.036deg)",
            transformOrigin: "center center",
            left: "50%",
            marginLeft: "-75vw",
          }}
        >
          <h2 className="text-lg min-[375px]:text-xl min-[425px]:text-2xl sm:text-3xl lg:text-5xl xl:text-[70px] font-bold text-[#2d2d2d] uppercase space-grotesk leading-[130%] text-center px-2 mx-24 min-[375px]:mx-32 min-[425px]:mx-36 sm:mx-40 lg:mx-10">
            Earn up to <span className="text-white">R20,000</span>
            <br className="hidden min-[425px]:block sm:block" />
            in rewards!
          </h2>
        </div>
      </motion.div>
      
      <div className="flex flex-col w-full max-w-[1440px] mx-auto py-6 min-[375px]:py-8 min-[425px]:py-10 sm:py-12 lg:py-16 px-4 min-[375px]:px-6 min-[425px]:px-8 sm:px-6 lg:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
        >
          <FeatureCarousel 
            slides={[
            {
              id: "feature-1",
              title: "Transparent Tracking",
              description: "Follow your referral's journey from submission to hire with real-time updates and complete visibility.",
              icon: iconCard1,
              backgroundGradient: feature1Bg
            },
            {
              id: "feature-2",
              title: "GUARANTEED REWARDS",
              description: "Get paid for successful referrals with our transparent reward structure. No fine print. No surprises.",
              icon: iconCard2,
              backgroundGradient: feature2Bg
            },
            {
              id: "feature-3",
              title: "Fast & Frictionless",
              description: "Submit referrals in seconds with our streamlined process. No complicated forms or lengthy sign-ups.",
              icon: iconCard3,
              backgroundGradient: feature3Bg
            },
            {
              id: "feature-4",
              title: "Trusted by Top Companies",
              description: "Join thousands of successful referrers working with leading companies across industries worldwide.",
              icon: iconCard4,
              backgroundGradient: feature4Bg
            }
          ]}
            autoplay={true}
            autoplayDelay={6000}
            className="mt-6 min-[375px]:mt-8"
          />
        </motion.div>
      </div>
    </section>
  );
}
